import { render } from "./Supersearch.vue?vue&type=template&id=841e4e6c"
import script from "./Supersearch.vue?vue&type=script&lang=js"
export * from "./Supersearch.vue?vue&type=script&lang=js"

import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css?vue&type=style&index=0&lang=css"
import "./Supersearch.vue?vue&type=style&index=1&id=841e4e6c&lang=css"

import exportComponent from "/tmp/build_2839a0f4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__